import type * as APITypes from '@/API';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

// Minimal version of listOrganizationUsersFiltered that avoids Cognito-backed fields
export const listOrganizationUsersFilteredLite =
  /* GraphQL */ `query ListOrganizationUsersFilteredLite(
  $filter: OrganizationUserFilter
  $limit: Int
  $nextToken: String
) {
  listOrganizationUsersFiltered(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      roles
      organizationId
      username
      role
      accountStatus
      groupsCanRead
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListOrganizationUsersFilteredQueryVariables,
    APITypes.ListOrganizationUsersFilteredQuery
  >;
